import React, { useEffect, useState } from 'react'
import Table from '../shared/table/Table';
import { FiEdit3 } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom';
import { fetchData } from '../../utils/options';
import { MdThumbDown, MdThumbUp } from 'react-icons/md';
import topTost from '../../utils/topTost';


const Loan_SchemesTable = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);

     useEffect(() => {
          window.scrollTo(0, 0);
          if (localStorage.getItem("access_token") === null) {
              navigate("/");
          }
      }, []);
  

  const fetchAllData = async () => {
    const result = await fetchData('get-loan-schemes', {}, "GET");

    if (result) {
      const user = result.data;
      setUserData(user || []);
    }
  };

  const toggleStatus = async (id) => {
    const result = await fetchData(`loan-schemes/toggle-status/${id}`, {}, 'POST');

    if (result && result.code === 200) {
      fetchAllData();
      if (result?.status === 1) {
        topTost({
          title: 'Status updated successfully: Active',
          icon: 'success',
        });
      } else {
        topTost({
          title: 'Status updated successfully: Deactive',
          icon: 'success',
        });
      }
    } else {
      console.error('Failed to toggle state status:', result?.message);
    }
  };

  const columns = [

    {
      accessorKey: 'actions',
      header: () => "Actions",
      cell: ({ row }) => {
        const id = row.original.id;
        const is_active = row.original.status;

        return (
          <div className="hstack gap-2 justify-content-end">
            <span
              className="cursor-pointer"
              onClick={() => navigate(`/Loan/edit-loan-schemes/${id}`)}
            >
              <FiEdit3 size={16} />
            </span>
            {is_active === 1 ? (
              <MdThumbUp
                className="cursor-pointer text-success"
                onClick={() => toggleStatus(id)}
              />
            ) : (
              <MdThumbDown
                className="cursor-pointer text-secondary"
                onClick={() => toggleStatus(id)}
              />
            )}
          </div>
        );
      },
      meta: {
        headerClassName: 'width-30', exportable: false,
      },
    },
    {
      accessorKey: 'scheme_name',
      header: () => 'Scheme Name',
      cell: (info) => info.getValue(),
        defaultIsVisible: true,
    },
    {
      accessorKey: 'interest_rate',
      header: () => 'Interest Rate (%)',
      cell: (info) => info.getValue(),
        defaultIsVisible: true,
    },
    {
      accessorKey: 'tenure_months',
      header: () => 'Tenure (Months)',
      cell: (info) => info.getValue(),
        defaultIsVisible: true,
    },
    {
      accessorKey: 'processing_fee',
      header: () => 'Processing Fee (₹)',
      cell: (info) => info.getValue(),
        defaultIsVisible: true,
    },
    {
      accessorKey: 'prepayment_allowed',
      header: () => 'Prepayment Allowed',
      cell: (info) => (info.getValue() === 1 ? 'Yes' : 'No'),
    },
    {
      accessorKey: 'scheme_description',
      header: () => 'Description',
      cell: (info) => info.getValue(),
      
    },
    {
      accessorKey: 'created_at',
      header: () => 'Created Date',
      cell: (info) => new Date(info.getValue()).toLocaleDateString('en-GB'),
        defaultIsVisible: true,
    },
  ]


  useEffect(() => {
    fetchAllData();
  }, [])
  return (
    <>
      <Table data={userData} columns={columns} />
    </>
  )
}

export default Loan_SchemesTable